import MapView from './views/MapView'
import useMap from './hooks/useMap'
import { wrap } from '../../../../../utils/globalUtils'
import { useMapProps } from './types'

const Map: React.FC<useMapProps> = wrap(MapView, useMap)
export default Map
